export const selectStreamPermissionsDialogOpen = (state) => !!state.streamPermissions?.dialogOpen;
export const selectMicPermissionMissing = (state) => !!state.streamPermissions?.micMissing;
export const selectLocalNetworkPermissionMissing = (state) => !!state.streamPermissions?.localNetworkMissing;
